export const ADMIN_GET_USERS_REQUEST = "ADMIN_GET_USERS_REQUEST";
export const ADMIN_GET_USERS_SUCCESS = "ADMIN_GET_USERS_SUCCESS";
export const ADMIN_GET_USERS_FAILURE = "ADMIN_GET_USERS_FAILURE";


export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const SINGLE_USER_REQUEST = "SINGLE_USER_REQUEST";
export const SINGLE_USER_SUCCESS = "SINGLE_USER_SUCCESS";
export const SINGLE_USER_FAILURE = "SINGLE_USER_FAILURE";

